import React from 'react'
import { Dialog, DialogTitle, DialogContent, makeStyles, Typography, DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    dialogTitle: {
        paddingRight: '0px',
        backgroundColor: theme.palette.primary.main,
        height: "16%",
    },
    // Test: {
    //     scrollSnapAlign:'start !important',
    // }
}))

export default function Modal_Frame(props) {

    var { title, children, maxWidth, isOpen, setOpen, setisOpenCloseQut, Actions } = props;
    const classes = useStyles();

    return (
        <Dialog open={isOpen} maxWidth={maxWidth} fullWidth >
            <DialogTitle className={classes.dialogTitle}>
                <div style={{ display: 'flex' }}>
                    <Typography variant="h4" component="div" style={{ flexGrow: 1, color: 'white', fontSize: 25 }}>
                        {title}
                    </Typography>
                    <Button
                        style={{ color: 'white', paddingTop: 1 }}
                        onClick={() => {
                            setOpen(false)
                        }}>
                        <CloseIcon />
                    </Button>

                </div>
            </DialogTitle>
            <DialogContent dividers  >
                {/* <DialogContent style={{scrollSnapAlign:'start !important'}} > */}
                {children}
            </DialogContent>
            <DialogActions>
                {Actions}
            </DialogActions>
        </Dialog>
    )
}